<template>
    <footer class="opacity-70 fixed bottom-8 left-12 flex flex-col items-center justify-between text-gray-400 text-xs space-y-3 sm:text-sm">
        <div class="flex items-center space-x-3">
            <p>&copy; {{ year }} {{ $page.props.companyName }}</p>
            <p>All rights reserved.</p>
        </div>
        <div class="flex space-x-3">
            <Link :href="route('policies', { filename: 'terms-of-service' })" class="hover:text-gray-600">Terms of Service</Link>
            <Link :href="route('policies', { filename: 'privacy-policy' })" class="hover:text-gray-600">Privacy Policy</Link>
        </div>
    </footer>
</template>

<script>
export default {
    computed: {
        year() {
            return moment().year()
        },
    },
}
</script>
